
export const PersonalAITabs = {
    QUIZZES: 'quizzes',
    RECOMMENDATIONS: 'recommendations',
};